import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { AppComponent } from './app.component';
import {
  AbsencesComponent, AbsencesNewComponent, DashboardComponent, HoursWorkedComponent, LoginComponent, LogoutComponent, MyHoursComponent,
  RequestsComponent, RequestsNewComponent, ReleasenotesComponent, MaintenanceComponent
} from './dialogs';
import {
  ExistingRequestsComponent
} from './partials';
import { CallbackPipe, CustomProffixService, HelpersService, LocalStorageService, UserSessionService } from './services';

import { AppConfiguration } from './app.configuration';

import {
  Configuration,
  ConnectionSettingsService,
  MitarbeiterService,
  StundenService,
  StundenartService,
  StundeninfoService,
  PxRestApiModule
} from '@proffix/restapi-angular-library';

const appRoutes: Routes = [
  { path: 'dashboard', component: DashboardComponent },
  { path: 'maintenance', component: MaintenanceComponent },
  { path: 'hours-worked', component: HoursWorkedComponent },
  { path: 'login', component: LoginComponent, data: { title: 'Login' } },
  { path: 'logout', component: LogoutComponent },
  { path: 'my-hours', component: MyHoursComponent },
  { path: 'requests', component: RequestsComponent },
  { path: 'requests/new', component: RequestsNewComponent },
  { path: 'requests/new/:stundenNr', component: RequestsNewComponent },
  { path: 'absences', component: AbsencesComponent },
  { path: 'absences/new', component: AbsencesNewComponent },
  { path: 'releasenotes', component: ReleasenotesComponent },
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  { path: '**', redirectTo: '/login', }
];

@NgModule({
  declarations: [
    AppComponent,
    // Dialogs
    AbsencesComponent,
    AbsencesNewComponent,
    CallbackPipe,
    DashboardComponent,
    HoursWorkedComponent,
    LoginComponent,
    LogoutComponent,
    MaintenanceComponent,
    MyHoursComponent,
    RequestsComponent,
    RequestsNewComponent,
    ReleasenotesComponent,
    // Partials
    ExistingRequestsComponent,
  ],
  imports: [
    CommonModule,
    HttpModule,
    BrowserModule,
    NgbModule.forRoot(),
    FormsModule,
    PxRestApiModule,
    RouterModule.forRoot(
      appRoutes,
      {
        enableTracing: false, // <-- debugging purposes only
        useHash: true, // .../#/crisis-center/
      }
    )
  ],
  providers: [
    // PROFFIX services
    MitarbeiterService,
    StundenService,
    StundenartService,
    StundeninfoService,
    AppConfiguration,

    // services from this app
    CustomProffixService,
    HelpersService,
    LocalStorageService,
    UserSessionService,

    { provide: Configuration, useExisting: AppConfiguration }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/.NET Projects/Angular Apps/TimeManagement/src/app/app.module.ts